import React from "react";
import { Box } from "@mui/material";
import { format, isValid, parse } from "date-fns";

import { PreviewField } from "../../components/PreviewField";

import type { Customer, CustomerOptions } from "../../../model/customer.model";

type PurchasePreviewProps = {
  customerCnpj: string;
  selectedCompany: CustomerOptions | null;
  customer: Customer | undefined;
  deliveryAddressId: string;
  withdrawBasisId: string;
  deliveryDate: string;
  freightType: string;
};

export function PurchasePreview({
  customerCnpj,
  selectedCompany,
  customer,
  deliveryAddressId,
  withdrawBasisId,
  deliveryDate,
  freightType,
}: PurchasePreviewProps) {
  if (!customerCnpj) return null;

  const companyName = selectedCompany?.value?.split("|")?.[0]?.trim() ?? "";
  const address = customer?.addresses?.find(
    (a) => String(a.id) === String(deliveryAddressId)
  );
  const addressStr = address?.street ?? "";
  const basis = customer?.withdrawBasis?.find(
    (b) => String(b.shippingPoint) === String(withdrawBasisId)
  );
  const basisStr = basis?.name ?? "";
  let formattedDate = "";
  if (deliveryDate) {
    const parsed = parse(deliveryDate, "yyyy-MM-dd'T'HH:mm:ss", new Date());
    formattedDate = isValid(parsed)
      ? format(parsed, "dd/MM/yyyy")
      : deliveryDate;
  }
  const freight = freightType ?? "";

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
      <PreviewField
        label="Razão social"
        value={`${customerCnpj} - ${companyName}`}
      />
      {addressStr && <PreviewField label="Endereço" value={addressStr} />}
      {formattedDate && (
        <PreviewField label="Data de entrega" value={formattedDate} />
      )}
      {basisStr && <PreviewField label="Base de retirada" value={basisStr} />}
      {freight && <PreviewField label="Frete" value={freight} />}
    </Box>
  );
}
